import React, { Component } from 'react';
import Slider, { Rail, Handles, Tracks } from 'react-compound-slider';
import './Slider.scss';

/* eslint no-unused-vars: off */
const Handle = ({ handle: { id, value, percent }, color, getHandleProps }) => (
  <div
    className="slider-handle"
    style={{
      left: `${percent}%`,
      backgroundColor: color
    }}
    {...getHandleProps(id)}
  />
);

const Track = ({ color, source, target, getTrackProps }) => (
  <div
    className="slider-track"
    style={{
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`,
      backgroundColor: color
    }}
    {...getTrackProps()}
  />
);

function toFiniteNumber(value, fallback = 0) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
}

export default class SliderComponent extends Component {
  render() {
    const { min, max, value, color, reversed, style, onChange } = this.props;
    const trackStyle = reversed ? { left: false, right: true } : { left: true, right: false };
    // react-compound-slider requires max > min (warns when both are 0, e.g. unset MTPD).
    const safeMin = toFiniteNumber(min, 0);
    const rawMax = toFiniteNumber(max, safeMin);
    const safeMax = rawMax > safeMin ? rawMax : safeMin + 1;
    const safeValue = Math.min(Math.max(toFiniteNumber(value, safeMin), safeMin), safeMax);
    const isDomainFallback = rawMax <= safeMin;

    return (
      <Slider
        domain={[safeMin, safeMax]}
        step={1}
        values={[safeValue]}
        reversed={reversed}
        disabled={isDomainFallback}
        onChange={(next) => {
          if (isDomainFallback || !onChange) return;
          onChange(next[0]);
        }}
        onUpdate={(next) => {
          if (isDomainFallback || !onChange) return;
          onChange(next[0]);
        }}
        className="slider"
        rootStyle={{ ...style, ...(isDomainFallback ? { opacity: 0.45, pointerEvents: 'none' } : null) }}
      >
        <Rail>{({ getRailProps }) => <div className="slider-rail" {...getRailProps()} />}</Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div>
              {handles.map(handle => (
                <Handle key={handle.id} color={color} handle={handle} getHandleProps={getHandleProps} />
              ))}
            </div>
          )}
        </Handles>
        <Tracks {...trackStyle}>
          {({ tracks, getTrackProps }) => (
            <div>
              {tracks.map(({ id, source, target }) => (
                <Track key={id} color={color} source={source} target={target} getTrackProps={getTrackProps} />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    );
  }
}
